// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

// Other
import { colors } from 'common/styles/style-constants';

// Styles
const Container = styled.div`
  color: ${colors.coral};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: ${(props) => props.margin};

  & > svg {
    height: ${(props) => props.height};
    width: ${(props) => props.width};
  }
`;

// Component
const GiftConfettiSvg = ({
  height = '15px',
  margin = '0px',
  width = '30px',
}) => (
  <Container height={height} margin={margin} width={width}>
    <svg
      width="80"
      height="67"
      viewBox="0 0 80 67"
      xmlns="http://www.w3.org/2000/svg"
      role="presentation"
    >
      <g fill="#F37F6E" fillRule="nonzero">
        <path d="M26.411 62.862h27.433a5.128 5.128 0 0 0 5.122-5.122V34.23a5.128 5.128 0 0 0-5.122-5.122h-5.622c.703-.412 1.272-.844 1.615-1.284a5.488 5.488 0 0 0-4.336-8.846c-1.64 0-3.261.731-4.341 2.13-.552.71-.93 1.997-1.19 3.446-.26-1.449-.637-2.732-1.188-3.447a5.475 5.475 0 0 0-4.342-2.13 5.488 5.488 0 0 0-4.336 8.847c.343.44.912.872 1.615 1.284H26.41a5.128 5.128 0 0 0-5.122 5.122v23.514a5.126 5.126 0 0 0 5.122 5.12zm-2.715-5.119V40.657h15.231v19.801H26.411a2.718 2.718 0 0 1-2.715-2.715zm32.867 0a2.718 2.718 0 0 1-2.716 2.716H41.332V40.657h15.23v17.086zM43.06 22.578a3.064 3.064 0 0 1 2.44-1.195 3.084 3.084 0 0 1 2.432 4.968c-.53.686-3.026 1.806-5.973 2.755h-.074c.18-3.112.64-5.836 1.175-6.528zm-11.056 3.773a3.083 3.083 0 0 1 4.876-3.773c.535.689.995 3.413 1.172 6.528h-.077c-2.944-.949-5.436-2.066-5.97-2.755zm-8.308 7.878a2.718 2.718 0 0 1 2.715-2.716h27.433a2.718 2.718 0 0 1 2.715 2.716v4.021H23.697V34.23zM58.73 6.044c-1.224-1.223-2.622-1.06-3.642-.94-.935.108-1.295.114-1.664-.255a1.204 1.204 0 0 0-1.7 0 1.204 1.204 0 0 0 0 1.7c.886.887 1.858 1.044 2.718 1.018a9.63 9.63 0 0 0 .923-.077c.932-.109 1.295-.114 1.664.254.368.37.363.73.254 1.664a9.749 9.749 0 0 0-.074.923c-.023.858.131 1.832 1.017 2.718.886.886 1.858 1.04 2.715 1.015a9.63 9.63 0 0 0 .924-.077c.931-.112 1.292-.115 1.657.251.366.366.36.726.252 1.658-.034.283-.066.595-.077.923-.026.858.131 1.832 1.014 2.716a1.2 1.2 0 0 0 1.698 0 1.204 1.204 0 0 0 0-1.701c-.366-.366-.36-.726-.251-1.658.12-1.02.286-2.418-.938-3.641-1.223-1.224-2.618-1.058-3.641-.94-.932.11-1.292.114-1.658-.252-.369-.369-.363-.729-.254-1.664.123-1.014.286-2.41-.938-3.635zM10.268 55.269c.294.56.311.654.24.812-.069.157-.149.208-.76.365-.1.026-.212.055-.324.086-.691.197-1.56.552-2.038 1.632a1.204 1.204 0 0 0 1.098 1.69c.46 0 .9-.266 1.1-.715.069-.157.149-.209.76-.366.721-.183 1.807-.463 2.364-1.72.558-1.258.035-2.25-.311-2.907-.294-.56-.309-.655-.24-.81.071-.157.148-.21.763-.368.717-.186 1.804-.463 2.364-1.724.557-1.257.037-2.252-.309-2.907-.294-.563-.309-.657-.24-.814a1.201 1.201 0 1 0-2.198-.975c-.48 1.083-.16 1.967.157 2.61.052.106.103.206.152.297.294.56.308.655.24.812-.072.157-.149.211-.763.368l-.323.086c-.692.197-1.561.555-2.041 1.635s-.16 1.964.157 2.61c.051.111.103.211.152.303zM69.153 46.525l-2.918 2.918-2.918-2.918-1.698 1.7 2.915 2.919-2.915 2.918.849.849.849.852 2.918-2.919 2.918 2.919 1.7-1.7-2.917-2.92 2.918-2.917zM44.124 3.986l-.85-.849-2.918 2.919-2.918-2.919-1.7 1.698 2.918 2.918-2.918 2.919 1.7 1.7 2.918-2.918 2.919 2.918 1.7-1.7-2.918-2.919 2.918-2.918zM70.591 27.995c0 3.016-4.527 3.016-4.527 0 0-3.018 4.527-3.018 4.527 0M9.525 34.549c0 3.018-4.525 3.018-4.525 0 0-3.015 4.525-3.015 4.525 0M15.624 18.574a5.056 5.056 0 0 0 5.05-5.05 5.056 5.056 0 0 0-5.05-5.05 5.056 5.056 0 0 0-5.05 5.05 5.057 5.057 0 0 0 5.05 5.05zm0-7.697a2.65 2.65 0 0 1 2.647 2.647 2.65 2.65 0 0 1-2.647 2.646 2.65 2.65 0 0 1-2.646-2.646 2.65 2.65 0 0 1 2.646-2.647z" />
      </g>
    </svg>
  </Container>
);
GiftConfettiSvg.propTypes = {
  height: PropTypes.string,
  margin: PropTypes.string,
  width: PropTypes.string,
};

export default GiftConfettiSvg;
